export const textStyles = {
    h1: {
        fontSize: '64px',
        fontWeight: 500,
        lineHeight: '70px',
    },
    h2: {
        fontSize: '48px',
        fontWeight: 500,
        lineHeight: '56px',
    },
    h3: {
        fontSize: '32px',
        fontWeight: 500,
        lineHeight: '40px',
    },
    subtitle1: {
        fontSize: '24px',
        fontWeight: 500,
        lineHeight: '40px',
    },
    subtitle2: {
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: '30px',
    },
    subtitle3: {
        fontSize: '18px',
        fontWeight: 700,
        lineHeight: '28px',
    },
    body1: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
    },
    body1Bold: {
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '24px',
    },
    body2: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
    },
    body2Bold: {
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: '20px',
    },
    body3: {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '16px',
    },
    body3Bold: {
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: '16px',
    },
    cta: {
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '26px',
    },
    caption: {
        fontSize: '10px',
        fontWeight: 700,
        lineHeight: '16px',
        letterSpacing: '0.2px',
    },
    overline: {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '18px',
        letterSpacing: '0.96px',
    },
};
